import {
  Create,
  ListButton,
  required,
  SaveButton,
  SimpleForm,
  NumberInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

import { MODULE_NAMES } from "@/constants";
import { ReferenceAutoCompleteInput } from "@/inputs/ReferenceAutoCompleteInput";

const CreateToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Create" />
    <ListButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const CreateActions = () => (
  <TopToolbar sx={{ justifyContent: "flex-start" }}>
    <ListButton />
  </TopToolbar>
);

export const CountryPricesCreate = () => (
  <Create actions={<CreateActions />} redirect="list">
    <SimpleForm toolbar={<CreateToolbar />}>
      <ReferenceAutoCompleteInput
        module={MODULE_NAMES.COUNTRIES}
        source="country"
        optionText="name"
        optionValue="code"
        validate={[required()]}
      />
      <NumberInput label="Cost" source="trialCost" validate={required()} />
    </SimpleForm>
  </Create>
);
